import { ReactNode, useEffect, useState } from 'react';
import { useMediaQuery } from '@/hooks/usePerformanceOptimizations';
import { measureDiscoverListColumnWidth } from './discoverColumnWidth';
import './profilePreviewList.css';

function useDiscoverListColumnWidth(enabled: boolean) {
    const [width, setWidth] = useState<number | null>(() => (
        enabled ? measureDiscoverListColumnWidth() : null
    ));

    useEffect(() => {
        if (!enabled) {
            setWidth(null);
            return undefined;
        }

        const measure = () => setWidth(measureDiscoverListColumnWidth());
        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [enabled]);

    return width;
}

interface DiscoverPreviewFrameProps {
    header?: ReactNode;
    children: ReactNode;
}

// Renders one Discover list card at the same column width Discover uses, so the
// card's container queries pick the same layout as the page.
const DiscoverPreviewFrame = ({ header, children }: DiscoverPreviewFrameProps) => {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const columnWidth = useDiscoverListColumnWidth(!isMobile);

    const card = columnWidth ? (
        <div className="profile-preview-list rounded-lg bg-white">
            <div className="profile-preview-list__grid">
                <div className="profile-preview-list__item">
                    {children}
                </div>
            </div>
        </div>
    ) : (
        <div className="min-w-0 w-full">{children}</div>
    );

    return (
        <div
            className="mx-auto flex max-w-full flex-col"
            style={columnWidth ? { width: columnWidth } : undefined}
        >
            {header}
            {card}
        </div>
    );
};

export default DiscoverPreviewFrame;
